export const MAX_SENTENCE_NOTE_TEXT_LENGTH = 260;
